import { z } from 'zod'
import type { SupportChat } from '../../models/SupportChat'

export const SupportChatDTO = z.object({
  is_whatsapp_active: z.boolean(),
  is_support_active: z.boolean(),
  support_subdomain: z.string().optional(),
  user: z.record(z.unknown()).optional(),
  tray_whitelabel_support_url: z.string().optional(),
  is_cheff_contract: z.boolean().optional(),
  chat_code: z.string().nullable().optional()
})

export type SupportChatDTO = z.infer<typeof SupportChatDTO>

export const SupportChatResponseDTO = z.object({
  data: SupportChatDTO
})

export type SupportChatResponseDTO = z.infer<typeof SupportChatResponseDTO>

export function mapDTOToSupportChat (dto: SupportChatDTO): SupportChat {
  return {
    isWhatsappActive: dto.is_whatsapp_active,
    isSupportActive: dto.is_support_active,
    supportSubdomain: dto.support_subdomain,
    user: dto.user as Record<string, unknown> | undefined,
    trayWhitelabelSupportUrl: dto.tray_whitelabel_support_url,
    isCheffContract: dto.is_cheff_contract ?? false,
    chatCode: dto.chat_code ?? undefined
  }
}
